export class MyContactsDTO {
    UserId: number;
    Name: string;
    Email: string;
    MobileNumber: string;
    IsGroup: string;
    ContactsGroup: MyGroupsDTO;
}

export class EndUserContactInfoDTO extends MyContactsDTO {
    IsChecked: boolean;
    ContactStatus: string;
    disableAssigned: boolean;
}

export class InvitesDTO {
    UserId: number;
    Name: string;
    Email: string;
    MobileNumber: string;
    InviteStatus: number;
}

export class RequestsDTO {
    UserId: number;
    Name: string;
    Email: string;
    MobileNumber: string;
    RequestStatus: number;
}

export class MyGroupsDTO {
    GroupId: string;
    GroupName: string;
    GroupMembers: Array<MyContactsDTO>;
}

export class ContactsDTO {
    MyContacts: Array<MyContactsDTO>;
    Invites: Array<InvitesDTO>;
    Requests: Array<RequestsDTO>;
    Groups: Array<MyGroupsDTO>;
}

export class ShareProcedureToContactsDTO extends MyContactsDTO {
    IsChecked: boolean;
}

export class ShareSurgeonToContactsDTO extends MyContactsDTO {
    IsChecked: boolean;
}

export class GroupContactsDTO extends MyContactsDTO {
    IsChecked: boolean;
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Contact.model.ts